module.exports = __webpack_public_path__ + "img/first-1.db672b22.webp";